import { Routes } from "@angular/router";
import { AuthGuardPresets } from "./guards/auth.guard";
import { UrlCollection } from "./constants/url-collection";
import {
  managerGoalSettingCanDeactivate
} from "./pages/manager-goal-setting/manager-goal-setting.guard";
import { adminCalibrationTalentMatrixCanDeactivate } from "./pages/admin/admin-calibration-talent-matrix/admin-calibration-talent-matrix.guard";

export const routes: Routes = [
  {
    // Root redirect a pagina SSO (default)
    path: "",
    redirectTo: UrlCollection.sso,
    pathMatch: "full"
  },
  // Pagine PUBBLICHE (senza guards) - Solo login
  {
    // SSO (OAuth 2.0 / OpenID Connect)
    path: UrlCollection.sso,
    loadComponent: async() => {
      const m = await import("./pages/sso/sso.component");
      return m.SsoComponent;
    }
  },
  {
    // Callback OAuth per SSO
    path: UrlCollection.oauthCallback,
    loadComponent: async() => {
      const m = await import("./pages/oauth-callback/oauth-callback.component");
      return m.OAuthCallbackComponent;
    }
  },
  {
    // Callback SAML per SSO (atterraggio post-ACS, completa il login lato client)
    path: UrlCollection.samlCallback,
    loadComponent: async() => {
      const m = await import("./pages/saml-callback/saml-callback.component");
      return m.SamlCallbackComponent;
    }
  },
  {
    // Pagina di errore del login SSO (mostra l'errore e permette il retry esplicito)
    path: UrlCollection.ssoError,
    loadComponent: async() => {
      const m = await import("./pages/sso-error/sso-error.component");
      return m.SsoErrorComponent;
    }
  },
  {
    // Login locale (email/password)
    path: UrlCollection.localAuthentication,
    loadComponent: async() => {
      const m = await import("./pages/local-authentication/local-authentication.component");
      return m.LocalAuthenticationComponent;
    }
  },
  {
    path: `${UrlCollection.registration}/:userId/:token`,
    loadComponent: async() => {
      const m = await import("./pages/registration/registration.component");
      return m.RegistrationComponent;
    }
  },
  {
    path: `${UrlCollection.resetPassword}/:userId/:token`,
    loadComponent: async() => {
      const m = await import("./pages/reset-password/reset-password.component");
      return m.ResetPasswordComponent;
    }
  },
  {
    path: UrlCollection.registrationConfirmation,
    loadComponent: async() => {
      const m = await import("./pages/registration-confirmation/registration-confirmation.component");
      return m.RegistrationConfirmationComponent;
    }
  },
  {
    path: `${UrlCollection.emailConfirmation}/:userId/:token`,
    loadComponent: async() => {
      const m = await import("./pages/email-confirmation/email-confirmation.component");
      return m.EmailConfirmationComponent;
    }
  },
  // Pagine PROTETTE (solo autenticazione)
  {
    path: UrlCollection.homepage,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/homepage/homepage.component");
      return m.HomepageComponent;
    }
  },
  {
    path: UrlCollection.profile,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/profile/profile.component");
      return m.ProfileComponent;
    }
  },
  {
    path: UrlCollection.showcase,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/showcase/showcase.component");
      return m.ShowcaseComponent;
    }
  },
  {
    path: UrlCollection.notifications,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/notifications/notifications.component");
      return m.NotificationsComponent;
    }
  },
  {
    path: UrlCollection.managerEvaluation,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-evaluation/manager-evaluation.component");
      return m.ManagerEvaluationComponent;
    }
  },
  {
    path: `${UrlCollection.managerEvaluation}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-evaluation/manager-evaluation.component");
      return m.ManagerEvaluationComponent;
    }
  },
  {
    path: `${UrlCollection.managerEvaluation}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-evaluation/manager-evaluation.component");
      return m.ManagerEvaluationComponent;
    }
  },
  {
    path: UrlCollection.managerGoalSetting,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    canDeactivate: [managerGoalSettingCanDeactivate],
    loadComponent: async() => {
      const m = await import("./pages/manager-goal-setting/manager-goal-setting.component");
      return m.ManagerGoalSettingComponent;
    }
  },
  {
    path: `${UrlCollection.managerGoalSetting}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    canDeactivate: [managerGoalSettingCanDeactivate],
    loadComponent: async() => {
      const m = await import("./pages/manager-goal-setting/manager-goal-setting.component");
      return m.ManagerGoalSettingComponent;
    }
  },
  {
    path: `${UrlCollection.managerGoalSetting}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    canDeactivate: [managerGoalSettingCanDeactivate],
    loadComponent: async() => {
      const m = await import("./pages/manager-goal-setting/manager-goal-setting.component");
      return m.ManagerGoalSettingComponent;
    }
  },
  // Consultazione valutazione self da manager
  {
    path: `${UrlCollection.managerSelfEvaluation}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-external-self-evaluation/manager-external-self-evaluation.component");
      return m.ManagerExternalSelfEvaluationComponent;
    }
  },
  // Personal pages
  // Nuova pagina Feedback employee (hub con tab + richiesta), cap. 1-6
  {
    path: UrlCollection.feedbackHub,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/employee-feedback-hub/employee-feedback-hub.component");
      return m.EmployeeFeedbackHubComponent;
    }
  },
  // La vecchia pagina Feedback employee è sostituita dall'hub: redirect per link entranti / deep-link esistenti
  {
    path: UrlCollection.personalFeedback,
    redirectTo: UrlCollection.feedbackHub,
    pathMatch: "full"
  },
  {
    path: `${UrlCollection.personalFeedback}/:feedbackType/:feedbackStatus/:feedbackUserId`,
    redirectTo: UrlCollection.feedbackHub,
    pathMatch: "full"
  },
  {
    path: UrlCollection.personalSendFeedback360,
    canActivate: [AuthGuardPresets.Authentication],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.personalSendFeedback360Details}/:feedback360Id`,
    canActivate: [AuthGuardPresets.Authentication],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: UrlCollection.personalFeedback360Proposal,
    canActivate: [AuthGuardPresets.Authentication],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.personalFeedback360Proposal}/:processId`,
    canActivate: [AuthGuardPresets.Authentication],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: UrlCollection.personalPrivateNotes,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.NoImpersonation],
    loadComponent: async() => {
      const m = await import("./pages/personal-private-notes/personal-private-notes.component");
      return m.PersonalPrivateNotesComponent;
    }
  },
  // Rotte Manager
  {
    path: UrlCollection.managerPrivateNotes,
    canActivate: [
      AuthGuardPresets.Authentication,
      AuthGuardPresets.Manager,
      AuthGuardPresets.NoImpersonation
    ],
    loadComponent: async() => {
      const m = await import("./pages/manager-private-notes/manager-private-notes.component");
      return m.ManagerPrivateNotesComponent;
    }
  },
  {
    path: `${UrlCollection.managerPrivateNotes}/:userId`,
    canActivate: [
      AuthGuardPresets.Authentication,
      AuthGuardPresets.Manager,
      AuthGuardPresets.NoImpersonation
    ],
    loadComponent: async() => {
      const m = await import("./pages/manager-private-notes/manager-private-notes.component");
      return m.ManagerPrivateNotesComponent;
    }
  },
  {
    path: `${UrlCollection.managerPrivateNotesSingleUser}/:userId`,
    canActivate: [
      AuthGuardPresets.Authentication,
      AuthGuardPresets.Manager,
      AuthGuardPresets.NoImpersonation
    ],
    data: { isSingleUserMode: true },
    loadComponent: async() => {
      const m = await import("./pages/manager-private-notes/manager-private-notes.component");
      return m.ManagerPrivateNotesComponent;
    }
  },
  {
    path: UrlCollection.managerDashboard,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-dashboard/manager-dashboard.component");
      return m.ManagerDashboardComponent;
    }
  },
  {
    path: `${UrlCollection.adminDevelopmentPlan}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Admin],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerDevelopmentPlan}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerDevelopmentPlan}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerDevelopmentPlan}`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: UrlCollection.managerFeedback360,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerFeedback360}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerFeedback360}/:userId/:processId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    // Nuova pagina Feedback manager (hub) - landing senza userId
    path: UrlCollection.managerFeedbackHub,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-feedback-hub/manager-feedback-hub.component");
      return m.ManagerFeedbackHubComponent;
    }
  },
  {
    // Nuova pagina Feedback manager (hub) - collaboratore selezionato
    path: `${UrlCollection.managerFeedbackHub}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-feedback-hub/manager-feedback-hub.component");
      return m.ManagerFeedbackHubComponent;
    }
  },
  {
    path: `${UrlCollection.managerFeedback}/:userId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerFeedback}/:userId/:feedbackStatus`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    path: `${UrlCollection.managerFeedback}/:userId/:feedbackType/:feedbackStatus/:feedbackUserId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    data: { errorData: { errorType: "501" } },
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  {
    // Dettaglio/approvazione del singolo feedback (manager) - per ID
    path: `${UrlCollection.managerFeedbackDetail}/:userId/:feedbackId`,
    canActivate: [AuthGuardPresets.Authentication, AuthGuardPresets.Manager],
    loadComponent: async() => {
      const m = await import("./pages/manager-feedback-detail/manager-feedback-detail.component");
      return m.ManagerFeedbackDetailComponent;
    }
  },
  // Autovalutazione
  {
    path: `${UrlCollection.personalSelfEvaluation}`,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/self-evaluation/self-evaluation.component");
      return m.SelfEvaluationComponent;
    }
  },
  // Goal setting personale (vista employee)
  {
    path: UrlCollection.personalGoalSetting,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/personal-goal-setting/personal-goal-setting.component");
      return m.PersonalGoalSettingComponent;
    }
  },
  {
    path: `${UrlCollection.personalGoalSetting}/:processId`,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/personal-goal-setting/personal-goal-setting.component");
      return m.PersonalGoalSettingComponent;
    }
  },
  {
    path: `${UrlCollection.personalSelfEvaluation}/:processId`,
    canActivate: [AuthGuardPresets.Authentication],
    loadComponent: async() => {
      const m = await import("./pages/self-evaluation/self-evaluation.component");
      return m.SelfEvaluationComponent;
    }
  },
  // 🔒 Admin area (con AuthGuard unificato)
  {
    path: UrlCollection.admin,
    canActivate: [
      AuthGuardPresets.Authentication, AuthGuardPresets.Admin, AuthGuardPresets.NoImpersonation
    ],
    children: [
      {
        path: "",
        loadComponent: async() => {
          const m = await import("./pages/admin/admin.component");
          return m.AdminComponent;
        }
      },
      {
        path: UrlCollection.adminHomepageSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-homepage/admin-homepage.component");
          return m.AdminHomepageComponent;
        }
      },
      {
        path: UrlCollection.adminCompetencesSetupSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/competences-setup/competences-setup.component");
          return m.AdminCompetencesSetupComponent;
        }
      },
      {
        path: UrlCollection.adminProcessSetupSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/process-setup/process-setup.component");
          return m.AdminProcessSetupComponent;
        }
      },
      // Dettaglio processo
      {
        path: UrlCollection.adminProcessSetupSubpath + "/:processId",
        loadComponent: async() => {
          const m = await import("./pages/admin/process-setup-details/process-setup-details.component");
          return m.AdminProcessSetupDetailsComponent;
        }
      },
      // Setup feedback - lista processi
      {
        path: UrlCollection.adminFeedbackSetupSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/feedback-setup/feedback-setup.component");
          return m.AdminFeedbackSetupComponent;
        }
      },
      // Setup feedback - dettaglio processo
      {
        path: UrlCollection.adminFeedbackSetupSubpath + "/:feedbackProcessId",
        loadComponent: async() => {
          const m = await import("./pages/admin/feedback-setup-details/feedback-setup-details.component");
          return m.AdminFeedbackSetupDetailsComponent;
        }
      },
      // Setup feedback - gestione tipologia
      {
        path: UrlCollection.adminFeedbackSetupSubpath + "/:feedbackProcessId/:feedbackProcessTypeId",
        loadComponent: async() => {
          const m = await import("./pages/admin/feedback-type-management/feedback-type-management.component");
          return m.AdminFeedbackTypeManagementComponent;
        }
      },
      {
        path: UrlCollection.adminManageUsersSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin-manage-users/admin-manage-users.component");
          return m.AdminManageUsersComponent;
        }
      },
      {
        path: UrlCollection.adminImpersonateSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-impersonate/admin-impersonate.component");
          return m.AdminImpersonateComponent;
        }
      },
      {
        path: UrlCollection.adminMonitoringSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/monitoring/monitoring.component");
          return m.AdminMonitoringComponent;
        }
      },
      {
        path: UrlCollection.adminMonitoringSubpath + "/:processId",
        loadComponent: async() => {
          const m = await import("./pages/admin/monitoring-details/monitoring-details.component");
          return m.AdminMonitoringDetailsComponent;
        }
      },
      {
        path: `${UrlCollection.adminHandleListFeedback360Subpath}/:processId/:userId`,
        data: { errorData: { errorType: "501" } },
        loadComponent: async() => {
          const m = await import("./components/ape-error-handler/ape-error-handler.component");
          return m.ApeErrorHandlerComponent;
        }
      },
      {
        path: `${UrlCollection.adminFeedbackDetailsSubpath}/:processId/:userId/:feedback360Id`,
        data: { errorData: { errorType: "501" } },
        loadComponent: async() => {
          const m = await import("./components/ape-error-handler/ape-error-handler.component");
          return m.ApeErrorHandlerComponent;
        }
      },
      {
        path: UrlCollection.adminCalibrationSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-calibration-talent-matrix/admin-calibration-talent-matrix.component");
          return m.AdminCalibrationTalentMatrixComponent;
        },
        // La simulazione non si salva: uscendo con persone spostate si chiede conferma
        canDeactivate: [adminCalibrationTalentMatrixCanDeactivate]
      },
      {
        path: `${UrlCollection.adminCalibrationSubpath}/:processId`,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-calibration-talent-matrix/admin-calibration-talent-matrix.component");
          return m.AdminCalibrationTalentMatrixComponent;
        },
        // La simulazione non si salva: uscendo con persone spostate si chiede conferma
        canDeactivate: [adminCalibrationTalentMatrixCanDeactivate]
      },
      {
        path: `${UrlCollection.adminCalibrationSubpath}/:processId/:userId`,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-calibration-talent-matrix/admin-calibration-talent-matrix.component");
          return m.AdminCalibrationTalentMatrixComponent;
        },
        // La simulazione non si salva: uscendo con persone spostate si chiede conferma
        canDeactivate: [adminCalibrationTalentMatrixCanDeactivate]
      },
      {
        // Schede di valutazione di un partecipante, in sola lettura: si apre dalla voce
        // "Visualizza schede" della lista utenti del monitoraggio
        path: `${UrlCollection.adminEvaluationCardsSubpath}/:processId/:userId`,
        loadComponent: async() => {
          const m = await import("./pages/admin/admin-evaluation-cards/admin-evaluation-cards.component");
          return m.AdminEvaluationCardsComponent;
        }
      },
      {
        path: UrlCollection.adminDashboardSubpath,
        loadComponent: async() => {
          const m = await import("./pages/admin-dashboard/admin-dashboard.component");
          return m.AdminDashboardComponent;
        }
      }
    ]
  },
  // Route esplicita per errore 403 (gestita dal guard)
  {
    path: "error/403",
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  },
  // Wildcard route per 404 (deve essere l'ultima)
  {
    path: "**",
    loadComponent: async() => {
      const m = await import("./components/ape-error-handler/ape-error-handler.component");
      return m.ApeErrorHandlerComponent;
    }
  }
];
